import { Injectable } from '@angular/core';
import { SurveyService } from '../../survey/survey.service';
import { SurveyUtilsService } from 'src/app/portal/form-processor/complex-forms-services/utils/survey.utils.service';
import { DetailsListWidgetService } from 'src/app/portal/form-processor/widgets/details-list/services/details-list.widget.service';

@Injectable({
  providedIn: 'root'
})
export class ApplicationChargesUtilsService {
  formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  constructor(private surveyService: SurveyService,
              private surveyUtilsService: SurveyUtilsService,
              private detailsListWidgetService: DetailsListWidgetService) {
  }

  processApplicationCharges(data: any) {
    const chargeSummary: any[] = [];
    const total = data.fees.reduce((acc: number, fee: any) => {

      chargeSummary.push({
        product_invoice_item_id: fee.id,
        description: fee.description,
        price: fee.price,
        tax: fee.tax,
        tag: fee.tag,
        recn_destination_id: fee.recn_destination_id
      });

      return acc + fee.price + fee.tax;
    }, 0);

    this.surveyService.surveyModel.setVariable('totalcharge', total);
    this.surveyService.surveyModel.setVariable('charges', data);
    this.surveyService.surveyModel.setVariable('chargeSummary', JSON.stringify(chargeSummary));

    const processedData = this.surveyUtilsService.getConfirmationChargesTable(data, total, this.formatter, this.surveyService.surveyModel.getValue('FirstName'), this.surveyService.surveyModel.getValue('LastName'));

    this.surveyService.surveyModel.setVariable('ConfirmationContentDetailsList', processedData);

    this.detailsListWidgetService.detailslistSubjects['ConfirmationContentDetailsList']?.detailslistSearchSubject.next('ConfirmationContentDetailsList');
  }
}
